import b from 'b_';
import { MarkdownExtXContent, Text } from 'platform-components';
// @ts-ignore
import { MdState } from 'platform-components/src/components/marker/types';
import * as userSelectors from 'platform-components/src/components/user/selectors';
import React from 'react';
import { connect } from 'react-redux';

import { ProblemInfo } from 'store/problems/typings';

import * as selectors from '../selectors';

import './problem-view__info.scss';

interface StoreProps {
    info: ProblemInfo | null;
    isCm: boolean;
    mdState: MdState | null;
}

interface Props extends StoreProps {}

export const ProblemViewInfo = ({ info, isCm, mdState }: Props) => {
    if (!info || !mdState) {
        return null;
    }

    return (
        <div className="problem-view__info">
            {isCm && info.comment && (
                <div className={b('problem-view', 'info-item')}>
                    <Text
                        id="lessonView.problemInfo.comment"
                        size={Text.SIZE.XL}
                        tagName={Text.TAG.P}
                        weight={Text.WEIGHT.L}
                    />
                    <Text>
                        <MarkdownExtXContent mdState={mdState}>{info.comment}</MarkdownExtXContent>
                    </Text>
                </div>
            )}
            {info.solution && (
                <div className={b('problem-view', 'info-item')}>
                    <Text
                        id="lessonView.problemInfo.solution"
                        size={Text.SIZE.XL}
                        tagName={Text.TAG.P}
                        weight={Text.WEIGHT.L}
                    />
                    <Text>
                        <MarkdownExtXContent mdState={mdState}>{info.solution}</MarkdownExtXContent>
                    </Text>
                </div>
            )}
            {info.publicSolution && (
                <div className={b('problem-view', 'info-item')}>
                    <Text
                        id="lessonView.problemInfo.publicSolution"
                        size={Text.SIZE.XL}
                        tagName={Text.TAG.P}
                        weight={Text.WEIGHT.L}
                    />
                    <Text>
                        <MarkdownExtXContent mdState={mdState}>{info.publicSolution}</MarkdownExtXContent>
                    </Text>
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (storeState: any): StoreProps => ({
    info: selectors.getProblemInfo(storeState),
    isCm: userSelectors.getIsContentManager(storeState),
    mdState: selectors.getProblemMdState(storeState),
});

export default connect(mapStateToProps)(ProblemViewInfo);
